const getPromoAgentRatingCommon = (state) => state.PromoAgentRating;

export const getPromoRating = (state) => getPromoAgentRatingCommon(state).promoRating;

